import { ViewProcessor } from "./index";
import { View } from "../index";

const triggerAttribute = 'data-flipcard-click-toggle';
const selector = `[${triggerAttribute}]`;

export default class FlipcardViewProcessor extends ViewProcessor
{
    public afterRender(view: View): PromiseLike<void>
    {
        let flipCards = view.querySelector(selector);

        for(let element of flipCards)
        {
            element.addEventListener('click', e => element.classList.toggle('toggled'));
        }

        return super.afterRender(view);
    }
}